import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { DataModel } from 'common/models/utility-models/base-model';
import { EmailTemplateModel } from 'common/models/page-models/Email-Template/email-template-data-model';
import { FormDataService } from '../../base-data-services/form-data.service';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplateFormDataService extends FormDataService<EmailTemplateModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.addEmailTemplate, http, ss);
  }

  getEditUrlAndMethod(id) {
    const edit = {
      url: environment.apiUrl + API_URL.templateEdit,
      method: API_METHODS.post,
    };
    return edit;
  }

   override getUpdatePayload(data){            
        const payload = {
            id: data.id
        }
        return payload;
    }

  createInstance(): EmailTemplateModel {
    return new EmailTemplateModel();
  }


  override getUpdateUrl() {
    return API_URL.updateTemplate;
  }
}

export { FormDataService };
